import React, { useEffect, useState, useMemo } from 'react';
import { db } from './firebase';
import { collection, getDocs } from 'firebase/firestore';
import { useBusinessAuth } from '../context/BusinessContext';
import FormSupplierVendas from '../../FrontEnd/Integration/FormSupplierVendas';

export default function FbBusinessVendas() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const { user } = useBusinessAuth();

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);

        const snap = await getDocs(collection(db, "orders"));
        const docs = snap.docs.map(d => ({ id: d.id, ...d.data() }));

        setOrders(docs);
      } catch (err) {
        console.error("Erro ao buscar pedidos:", err);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  const ordersWithSupplierItems = useMemo(() => {
    if (!user) return [];

    return orders.map((order) => {
      const basket = Array.isArray(order?.items?.basket)
        ? order.items.basket
        : [];

      const supplierItems = basket.filter(
        (item) => item?.idSupplier === user.uid && item?.status === "Sold"
      );

      return {
        ...order,
        supplierItems,
      };
    });
  }, [orders, user]);


  const supplierItemsOnly = useMemo(() => {
  return ordersWithSupplierItems
    .flatMap(order => order.supplierItems); 
}, [ordersWithSupplierItems]);


  return (
    <div>

  
      <FormSupplierVendas venda={supplierItemsOnly}/>
    </div>
  );
}